export default "__VITE_ASSET__0z_LsF8K__"